import { mapResourceName } from '@/shared/services/ObjectDisplayService';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import { useEffect, useState } from 'react';
export const mapResourcesToTree = (orgItems, intl) => {
    if (!orgItems || !orgItems.length) {
        return [];
    }
    return orgItems
        .filter(x => x.isDefault && x.categoryId)
        .reduce((array, category) => {
        const categoryLabel = mapResourceName(category, intl);
        const subResources = orgItems
            .filter(s => !s.isDefault && s.categoryId && s.categoryId === category.categoryId)
            .map(resource => {
            const label = mapResourceName(resource, intl, false, true);
            return Object.assign(Object.assign({}, resource), { id: resource.id, key: resource.id, model: resource, label,
                categoryLabel, search: `${categoryLabel};${label}`, level: 1, disabled: resource.disabled });
        });
        // const subResourcesLabels = subResources.map(x => x.label).join(';');
        return array.concat([
            Object.assign(Object.assign({}, category), { id: category.id, key: category.id, model: category, label: categoryLabel, categoryLabel, search: categoryLabel, level: 0, disabled: category.disabled }),
            ...subResources,
        ]);
    }, [])
        .sort(dynamicSortMultiple('categoryLabel', 'level', 'label'));
};
const useResourceTree = (orgItems, intl) => {
    const [items, setItems] = useState([]);
    useEffect(() => {
        setItems(mapResourcesToTree(orgItems, intl));
    }, [intl, orgItems]);
    return items;
};
export default useResourceTree;
